import { alpha, Box, styled, Typography } from '@mui/material'
import { IFilterButton } from './types'
import { preventForwardProps } from 'utils/styledUtils'

export const CategoryFiltersContainer = styled(Box)(({ theme }) => ({
  background: alpha(theme.palette.surface[50], 0.08),
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  padding: theme.spacing(4, 2),
  gap: theme.spacing(2),
  marginBottom: theme.spacing(4),
  flexWrap: 'nowrap',
  overflowX: 'auto',
  [theme.breakpoints.up('sm')]: {
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
}))

export const FilterButton = styled(
  Typography,
  preventForwardProps(['categoryId', 'activeCategory']),
)<IFilterButton>(({ theme, categoryId, activeCategory }) => ({
  ...theme.typography.body2,
  display: 'flex',
  height: '32px',
  padding: theme.spacing(0.5, 2),
  justifyContent: 'center',
  alignItems: 'center',
  background:
    categoryId === activeCategory
      ? alpha(theme.palette.primary.main, 0.35)
      : alpha(theme.palette.surface[50], 0.08),
  borderRadius: '16px',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  '&:hover': {
    background: alpha(theme.palette.primary.main, 0.35),
  },
}))
